import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class Term extends Component {
  constructor(props) {
    super(props);
    this.state = { value: '', charsLeft: this.props.maxLength };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
      charsLeft: this.props.maxLength - event.target.value.length
    });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const { t } = this.props;
    const name1 = this.props.projectObject.name;
    const maxLength = this.props.maxLength;
    const charsLeft = this.state.charsLeft;
    let description = (
      <Trans i18nKey="describe">
        Describe one thing you like about "{{ name1 }}
        :"
      </Trans>
    );
    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            description={description}
            skip={this.props.skip}
            pairId={this.props.pair.pairId}
          />
          <div className="App-answer-text instructions">
            <Trans i18nKey="maxLetters">
              Max. {{ maxLength }} letters ({{ charsLeft }} left):
            </Trans>
          </div>
          <div className="input-group App-answer-text App-answer">
            <input
              autoFocus
              type="text"
              className="form-control"
              onChange={this.handleChange}
              value={this.state.value}
              maxLength={this.props.maxLength}
            />
          </div>
          <NextQuestionButton
            to={this.props.url + '/opposite'}
            onClick={() => this.props.save(this.state.value)}
            disabled={this.state.value ? false : true}
            text={t('SUBMIT')}
          />
          <div className="App-answer-button">
            <button
              className="btn btn-light btn-round btn-block"
              onClick={this.props.history.goBack}
            >
              {t('BACK')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(translate('translations')(Term));



// WEBPACK FOOTER //
// ./src/preference/components/Pair/term.js